import { Component, Prop, Host, State, Listen, h } from '@stencil/core';
import { IconSize } from '../../sew-svg-icon/sew-icon.types';

@Component({
    tag: 'sew-ws-link',
    styleUrl: 'sew-ws-link.scss',
    shadow: true,
})
export class SewWsLink {
    /**
     * State of button.
     */
    @Prop({ reflect: true }) type:
        | 'default'
        | 'external'
        | 'anchor'
        | 'download'
        | 'email'
        | 'protected'
        | 'back' = 'default';
    @Prop({ reflect: true }) size: 'default' | 'large' | 'xl' | 'bold' = 'default';
    @Prop({ reflect: true }) os = false;
    @State() stackUp = false;

    @Listen('tooltipToggle')
    public onTooltipToggle(event: CustomEvent<boolean>): void {
        this.stackUp = event.detail;
    }

    private icons = {
        default: 'arrow-east',
        external: 'launch',
        anchor: 'arrow-down',
        download: 'download',
        protected: 'lock-locked',
        email: 'mail',
        back: 'arrow-west',
    };

    private iconSize = {
        default: 's',
        large: 'm',
        xl: 'l',
        bold: 's',
    };

    private iconsXl = {
        default: 'arrow-right',
    };

    private icon() {
        if (this.size === 'xl' || this.size === 'large') {
            return this.iconsXl[this.type];
        }

        return this.icons[this.type];
    }

    render() {
        return (
            <Host
                class={{
                    'stack-up': this.stackUp,
                }}
            >
                <span>
                    <sew-icon class="svg" size={this.iconSize[this.size] as IconSize} icon={this.icon()} />
                    <slot></slot>
                </span>
            </Host>
        );
    }
}
